var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Sort")]),_c('Explain'),_c('SingleSort'),_c('MultiSort'),_c('SortAlways'),_c('API',{attrs:{"title":"API","anchor":"API","desc":"sortOption Sort option"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }